import { useEffect, useRef, useState } from "react";

const surEchap = (onAnnuler) => (evenement) => {
  if (evenement.key === "Escape") {
    evenement.preventDefault();
    evenement.stopPropagation();
    onAnnuler();
  }
};

// Note d'une tâche, éditée en place sous le nom. Entrée dans la zone de texte
// ajoute une ligne ; Échap annule, le bouton enregistre.
export const NoteTache = ({ todo, onEnregistrer, onAnnuler }) => {
  const [valeur, setValeur] = useState(todo.text || "");
  const ref = useRef(null);
  const id = `tl-note-${todo.id}`;

  useEffect(() => {
    const zone = ref.current;
    if (!zone) return;
    zone.focus();
    zone.setSelectionRange(zone.value.length, zone.value.length);
  }, []);

  return (
    <form
      className="tl-editeur"
      onSubmit={(evenement) => {
        evenement.preventDefault();
        onEnregistrer(valeur.trim());
      }}
      onKeyDown={surEchap(onAnnuler)}
    >
      <label className="tl-sr-only" htmlFor={id}>
        Note de la tâche
      </label>
      <textarea id={id} ref={ref} value={valeur} onChange={(evenement) => setValeur(evenement.target.value)} placeholder="Note pour l'équipe…" />
      <div className="tl-editeur__actions">
        <button type="button" className="tl-bouton tl-bouton--lien" onClick={onAnnuler}>
          Annuler
        </button>
        <button type="submit" className="tl-bouton tl-bouton--primaire">
          Enregistrer
        </button>
      </div>
    </form>
  );
};

// Changement de tâche : un choix dans le catalogue du produit, puis validation.
// La note, l'état et l'ordre sont conservés par la page.
export const ChangerTache = ({ todo, taches, onChanger, onAnnuler }) => {
  const [taskId, setTaskId] = useState(String(todo.taskId));
  const ref = useRef(null);
  const id = `tl-changer-${todo.id}`;

  useEffect(() => {
    if (ref.current) ref.current.focus();
  }, []);

  return (
    <form
      className="tl-editeur"
      onSubmit={(evenement) => {
        evenement.preventDefault();
        if (taskId === String(todo.taskId)) onAnnuler();
        else onChanger(taskId);
      }}
      onKeyDown={surEchap(onAnnuler)}
    >
      <label className="tl-sr-only" htmlFor={id}>
        Nouvelle tâche
      </label>
      <select id={id} ref={ref} value={taskId} onChange={(evenement) => setTaskId(evenement.target.value)}>
        {taches.map((tache) => (
          <option key={tache.id} value={String(tache.id)}>
            {tache.name}
          </option>
        ))}
      </select>
      <span className="tl-editeur__aide">La note, l'état et l'ordre sont conservés.</span>
      <div className="tl-editeur__actions">
        <button type="button" className="tl-bouton tl-bouton--lien" onClick={onAnnuler}>
          Annuler
        </button>
        <button type="submit" className="tl-bouton tl-bouton--primaire">
          Changer
        </button>
      </div>
    </form>
  );
};
